import type { RouteObject } from 'react-router-dom';
import { paths } from '@/router/paths';
import { DashboardPage } from './DashboardPage';

export const dashboardRoutes: RouteObject[] = [
  { path: paths.dashboard, element: <DashboardPage /> }
];
